import { InjectionToken } from '@angular/core';

import { LatLng } from '../models/brouter-map.model';

/**
 * Port of `brouter-web-master/config/config.js` (`BR.conf`).
 *
 * Only the keys reachable in the SQS build are kept; the profile editor, transit,
 * Strava and share features were already disabled in the fork.
 */
export interface BrouterMapConfig {
  /** Base URL of the BRouter engine. Requests are issued as `{host}/brouter?...`. */
  host: string;
  /** Selectable routing profiles. The first entry is the default and is omitted from URLs. */
  profiles: string[];
  /** Legacy profile names remapped when parsing previously serialised route state. */
  profilesRename: Record<string, string>;
  initialMapLocation: LatLng;
  initialMapZoom: number;
  /** Index into the base layer list used on first load. */
  defaultBaseLayerIndex: number;
  /** Initial route line opacity, overridden by the stored slider setting. */
  defaultOpacity: number;
  /** Lower bound applied to the stored opacity on load, so a route can never load invisible. */
  minOpacity: number;
  /** Kept in sync with the server, see `ServerHandler.getTrackName()`. */
  tracknameAllowedChars: string;
  /** Maximum size in bytes for locally loaded track files. */
  trackSizeLimit: number;
}

export const BROUTER_MAP_CONFIG = new InjectionToken<BrouterMapConfig>('BROUTER_MAP_CONFIG');

/**
 * Reverse-proxy path to the routing engine, resolved against the app base URL in every
 * environment. Distinct from runtime config's `brouterEndpoint`, which addressed the
 * retired brouter-web iframe. `proxy.conf.json` stands in for the proxy under `ng serve`.
 */
export const brouterEnginePath = 'brouter-master-dev';

export const defaultBrouterMapConfig: BrouterMapConfig = {
  host: brouterEnginePath,
  profiles: ['rail'],
  profilesRename: { 'hiking-beta': 'hiking-mountain' },
  initialMapLocation: { lat: 50.99, lng: 9.86 },
  initialMapZoom: 5,
  // OpenStreetMap, the first entry in the base layer list.
  defaultBaseLayerIndex: 0,
  defaultOpacity: 0.67,
  minOpacity: 0.3,
  tracknameAllowedChars: 'a-zA-Z0-9 \\._\\-',
  trackSizeLimit: 1024 * 10
};
